import { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { BodyClass, flattenToAppURL } from '@plone/volto/helpers';
import { Container } from 'semantic-ui-react';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';

/**
 * Not found function.
 * @function NotFound
 * @returns {string} Markup of the not found page.
 */
const NotFound = (props) => {
  const { content, pathname } = props;
  const navroot = useSelector((state) => state.navroot?.data);
  const history = useHistory();
  const language = useSelector((state) => state.intl.locale);
  const [showNotFound, setShowNotFound] = useState(false);

  useEffect(() => {
    if (pathname === '/es/pagina-no-encontrada' || pathname === '/ca/pagina-no-trobada' || pathname === '/en/page-not-found') {
      setShowNotFound(true)
      return;
    }
    if (!__SERVER__) {
      if (language === 'ca') {
        window.location.href = flattenToAppURL('/ca/pagina-no-trobada');
      } else if (language === 'es') {
        window.location.href = flattenToAppURL('/es/pagina-no-encontrada');
      } else {
        window.location.href = flattenToAppURL('/en/page-not-found');
      }
    } else {
      if (language === 'ca') {
        history.replace(flattenToAppURL('/ca/pagina-no-trobada'));
      } else if (language === 'es') {
        history.replace(flattenToAppURL('/es/pagina-no-encontrada'));
      } else {
        history.replace(flattenToAppURL('/en/page-not-found'));
      }
    }
  }, [history]);

  return showNotFound ? (
    <Container className="view-wrapper py-5">
      <BodyClass className="page-not-found" />
      <h1>
        <FormattedMessage
          id="This page does not seem to exist…"
          defaultMessage="This page does not seem to exist…"
        />
      </h1>
      <p className="description">
        <FormattedMessage
          id="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
          defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
        />
      </p>
      <p>
        <FormattedMessage
          id="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          defaultMessage="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          values={{
            site_admin: (
              <Link to="/contact-form">
                <FormattedMessage
                  id="Site Administration"
                  defaultMessage="Site Administration"
                />
              </Link>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  ) : (
    <></>
  );
};

export default NotFound;

